import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-paper border-t border-white/10">
    <div className="container-x py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo className="h-8" />
          <p className="mt-4 font-display text-sm font-medium text-paper/80">
            Practical <span className="text-bolt">HR</span> support for startups and SMEs
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-paper/60">
            The anti-corporate HR ally for UK founders and SMEs of 5 to 50 people. Plain English, same-day answers, no retainers.
          </p>
          <div className="mt-6 space-y-2 text-sm text-paper/70">
            <p className="flex items-center gap-2"><MapPin size={15} className="text-pink" /> Suite 100, 7 Kenden Business Park, Maritime Close, Rochester, Kent ME2 4JF</p>
            <a href="mailto:hello@electra-hr.com" data-testid="footer-email-link" className="flex items-center gap-2 hover:text-pink transition-colors">
              <Mail size={15} className="text-pink" /> hello@electra-hr.com
            </a>
            <a href="tel:+441622957300" data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-pink transition-colors">
              <Phone size={15} className="text-pink" /> 01622 957 300
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-pink">Services</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              ["day-to-day-hr-advice", "Day-to-Day HR Advice"],
              ["grievances-disciplinaries", "Grievances & Disciplinaries"],
              ["contracts-handbooks", "Contracts & Handbooks"],
              ["hr-health-checks", "HR Health Checks"],
              ["training-and-change", "Training & Change"],
              ["startup-packages", "Startup HR Packages"],
            ].map(([slug, label]) => (
              <li key={slug}>
                <Link to={`/services/${slug}`} data-testid={`footer-service-${slug}`} className="text-paper/60 hover:text-pink transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow text-pink">Company</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/about" data-testid="footer-link-about" className="text-paper/60 hover:text-pink transition-colors">About</Link></li>
            <li><Link to="/blog" data-testid="footer-link-blog" className="text-paper/60 hover:text-pink transition-colors">Briefings</Link></li>
            <li><Link to="/calculators" data-testid="footer-link-calculators" className="text-paper/60 hover:text-pink transition-colors">Free Calculators</Link></li>
            <li><Link to="/equality-at-work" data-testid="footer-link-equality" className="text-paper/60 hover:text-pink transition-colors">Equality at Work</Link></li>
            <li><Link to="/faqs" data-testid="footer-link-faqs" className="text-paper/60 hover:text-pink transition-colors">FAQs</Link></li>
            <li><Link to="/hr-consultant-kent" data-testid="footer-link-kent" className="text-paper/60 hover:text-pink transition-colors">HR Consultant Kent</Link></li>
            <li><Link to="/hr-consultancy-uk" data-testid="footer-link-uk" className="text-paper/60 hover:text-pink transition-colors">HR Consultancy UK</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-paper/60 hover:text-pink transition-colors">Contact</Link></li>
            <li><a href="https://themarketingstudiouk.com/guides" data-testid="footer-link-marketing-studio-guides" className="text-paper/60 hover:text-pink transition-colors">Marketing Studio guides</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow text-pink">Legal</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-paper/60 hover:text-pink transition-colors">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" data-testid="footer-link-cookies" className="text-paper/60 hover:text-pink transition-colors">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8">
        <p data-testid="footer-compliance-note" className="flex gap-3 text-xs leading-relaxed text-paper/45 max-w-4xl">
          <ShieldCheck size={28} className="shrink-0 text-pink/70" />
          <span>
            Electra HR is an HR consultancy led by a solicitor-director. Electra HR is not a law firm and is not authorised or
            regulated by the Solicitors Regulation Authority. Where a matter requires legal advice, representation or the
            protection of legal professional privilege, those services are provided separately by Bonsai Law, an SRA-regulated
            law firm.
          </span>
        </p>
        <p className="mt-6 font-mono text-xs text-paper/35">© {new Date().getFullYear()} Electra HR Ltd · Company No. 11077627 · Rochester, Kent, United Kingdom</p>
      </div>
    </div>
  </footer>
);
